import { useSEO } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PoliticaPrivacidadePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Política de Privacidade | Consultadoria de Serviços em Saúde',
    description: 'Política de privacidade da Consultadoria de Serviços em Saúde, SA. Informações sobre como tratamos e protegemos os seus dados pessoais em conformidade com a legislação em vigor.',
    keywords: 'política privacidade, proteção dados, RGPD, confidencialidade, segurança dados',
    canonical: '/politica-privacidade',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Política de Privacidade',
      description: 'Política de privacidade da Consultadoria de Serviços em Saúde, SA',
      url: `${siteUrl}/politica-privacidade`
    }
  });

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-24">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Privacidade</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-PT')}
            </p>

            <section className="mb-12">
              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg mb-8">
                <p className="text-gray-700 leading-relaxed">
                  A empresa <strong>Consultadoria de Serviços em Saúde, SA</strong> é totalmente responsável pelo tratamento dos dados pessoais que forem recolhidos pela utilização deste website. Garante, assim, aos utilizadores total privacidade, confidencialidade e segurança dos dados partilhados, incluindo os seus dados pessoais ou empresariais, em estreito cumprimento da legislação em vigor, designadamente a <strong>Lei 67/98 de 26 de outubro</strong> e a <strong>Lei 41/2004 de 18 de Agosto</strong>.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Compromissos e Garantias</h2>
              
              <div className="space-y-6">
                <div className="bg-white border border-gray-200 p-6 rounded-lg hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Confidencialidade dos Dados</h3>
                      <p className="text-gray-600 leading-relaxed">
                        A base de dados criada a partir do preenchimento do formulário de contacto neste website assegura a total confidencialidade dos dados recolhidos, de forma a Consultadoria de Serviços em Saúde, SA poder utilizar esses dados para efetuar um contacto direto, relativamente a novos serviços ou atualização de serviços existentes.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-lg hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-file-text-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Utilização Comercial</h3>
                      <p className="text-gray-600 leading-relaxed">
                        No momento da celebração do contrato de prestação de serviços com a Consultadoria de Serviços em Saúde, SA, os dados solicitados serão para estrito uso comercial, nomeadamente, para faturação, contacto ou efeitos estatísticos.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-lg hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-lock-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Não Divulgação a Terceiros</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Em caso algum os dados pessoais do utilizador serão divulgados ou fornecidos a terceiros ou utilizados para efeitos de publicidade ou marketing, sem o consentimento expresso do utilizador, exceto se o utilizador violar os termos e condições de utilização do serviço. Nessa situação, os dados pessoais do utilizador poderão ser utilizados para efeitos de responsabilidade civil, contraordenacional ou criminal.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-lg hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-shield-user-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Segurança e Eficácia</h3>
                      <p className="text-gray-600 leading-relaxed">
                        As presentes condições visam assegurar ao utilizador um aproveitamento seguro e eficaz dos serviços fornecidos pela Consultadoria de Serviços em Saúde, SA.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border border-gray-200 p-6 rounded-lg hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-links-line text-2xl text-teal-600"></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-3">Websites de Terceiros</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Este website poderá apresentar ligações para diversos outros websites, nomeadamente de clientes e/ou parceiros. No entanto a Consultadoria de Serviços em Saúde, SA não se responsabiliza pela política de segurança e privacidade desses websites de terceiros.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Recolha e Tratamento de Dados</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Dados Recolhidos</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Os dados pessoais recolhidos através deste website incluem:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                  <li>Nome completo</li>
                  <li>Endereço de e-mail</li>
                  <li>Número de telefone</li>
                  <li>Informações fornecidas nos formulários de contacto</li>
                  <li>Dados de navegação (cookies)</li>
                </ul>

                <h3 className="text-lg font-bold text-gray-900 mb-4">Finalidade do Tratamento</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Os dados pessoais recolhidos são utilizados para:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Responder a pedidos de informação e contacto</li>
                  <li>Prestação de serviços contratados</li>
                  <li>Faturação e gestão comercial</li>
                  <li>Comunicação de novos serviços ou atualizações</li>
                  <li>Análise estatística e melhoria dos serviços</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Direitos dos Utilizadores</h2>
              <div className="bg-teal-50 p-6 rounded-lg">
                <p className="text-gray-700 leading-relaxed mb-4">
                  Em conformidade com a legislação aplicável, os utilizadores têm os seguintes direitos:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><strong>Direito de Acesso:</strong> Pode solicitar informações sobre os dados pessoais que detemos</li>
                  <li><strong>Direito de Retificação:</strong> Pode solicitar a correção de dados incorretos ou desatualizados</li>
                  <li><strong>Direito de Eliminação:</strong> Pode solicitar a eliminação dos seus dados pessoais</li>
                  <li><strong>Direito de Oposição:</strong> Pode opor-se ao tratamento dos seus dados para determinadas finalidades</li>
                  <li><strong>Direito de Portabilidade:</strong> Pode solicitar a transferência dos seus dados para outro responsável</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Segurança dos Dados</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                A Consultadoria de Serviços em Saúde, SA implementa medidas técnicas e organizativas adequadas para proteger os dados pessoais contra destruição acidental ou ilícita, perda acidental, alteração, difusão ou acesso não autorizado, bem como contra qualquer outra forma de tratamento ilícito.
              </p>
              <div className="grid md:grid-cols-3 gap-4 mt-6">
                <div className="bg-white border border-gray-200 p-4 rounded-lg text-center">
                  <i className="ri-lock-password-line text-3xl text-teal-600 mb-2"></i>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">Encriptação</h4>
                  <p className="text-xs text-gray-600">Dados protegidos com tecnologia SSL</p>
                </div>
                <div className="bg-white border border-gray-200 p-4 rounded-lg text-center">
                  <i className="ri-server-line text-3xl text-teal-600 mb-2"></i>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">Servidores Seguros</h4>
                  <p className="text-xs text-gray-600">Infraestrutura protegida e monitorizada</p>
                </div>
                <div className="bg-white border border-gray-200 p-4 rounded-lg text-center">
                  <i className="ri-user-lock-line text-3xl text-teal-600 mb-2"></i>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">Acesso Restrito</h4>
                  <p className="text-xs text-gray-600">Apenas pessoal autorizado</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Aceitação dos Termos</h2>
              <div className="bg-gray-900 text-white p-6 rounded-lg">
                <p className="leading-relaxed">
                  Os utilizadores do website Consultadoria de Serviços em Saúde, SA aceitam, assim, os termos e condições expressos nesta Política de Privacidade.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Alterações à Política de Privacidade</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                A Consultadoria de Serviços em Saúde, SA reserva-se o direito de alterar esta Política de Privacidade a qualquer momento. Quaisquer alterações serão publicadas nesta página e, quando apropriado, notificadas por e-mail. Recomendamos que consulte regularmente esta página para se manter informado sobre como protegemos os seus dados.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Contacte-nos</h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                Para qualquer esclarecimento adicional sobre a nossa Política de Privacidade e Termos e Condições deste website ou caso o utilizador note alguma quebra desta segurança de dados poderá reportá-la através dos seguintes contactos:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <i className="ri-mail-line text-teal-600 text-xl"></i>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">E-mail</p>
                      <a href="mailto:consultadoriaeservicosemsaude@gmail.com" className="text-gray-900 hover:text-teal-600 transition-colors font-medium">
                        consultadoriaeservicosemsaude@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-phone-line text-teal-600 text-xl"></i>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Telefone</p>
                      <a href="tel:919214659" className="text-gray-900 hover:text-teal-600 transition-colors font-medium">
                        919 214 659
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-time-line text-teal-600 text-xl"></i>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Horário de Atendimento</p>
                      <p className="text-gray-900 font-medium">Segunda a Sexta: 9h - 18h</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="bg-teal-600 text-white p-6 rounded-lg">
              <div className="flex items-start gap-4">
                <i className="ri-information-line text-2xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="font-bold mb-2">Legislação Aplicável</p>
                  <p className="text-sm leading-relaxed">
                    Esta Política de Privacidade está em conformidade com a <strong>Lei 67/98 de 26 de outubro</strong> (Lei da Proteção de Dados Pessoais), a <strong>Lei 41/2004 de 18 de Agosto</strong> e o <strong>Regulamento Geral sobre a Proteção de Dados (RGPD)</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}